import type { Place } from 'owa-graph-schema';
import { createObservableOperation } from 'owa-observable-operation';

import { getPlacesService } from 'places-service';
import type { TraceErrorObject } from 'owa-analytics-types';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

const emptyKey = '';

const dest = createObservableOperation(
    'PLACES_LOAD_LOCATIONS',
    (): {} => ({}),
    ({}) => emptyKey,
    () => getPlacesService().getPlaces(),
    () => getModuleContextMailboxInfo()
);
const isInProgress: (key: '') => boolean = dest.isInProgress;
const getLastError: (key: '') => TraceErrorObject | undefined = dest.getLastError;
const loadPlaces: () => {} = dest.start;
const loadPlacesSucceeded: (actionMessage: { result: Map<string, Place> }) => {
    result: Map<string, Place>;
} = dest.onSucceeded;
const loadPlacesFailed: (
    actionMessage: {},
    error?: TraceErrorObject
) => {
    error?: TraceErrorObject;
} = dest.onFailed;
const loadPlacesAsync: () => Promise<Map<string, Place>> = dest.startAsync;

const loadPlacesInProgress: () => boolean = isInProgress.bind(null, emptyKey);
const getPlacesLastError: () => TraceErrorObject | undefined = getLastError.bind(null, emptyKey);

export {
    loadPlacesInProgress,
    getPlacesLastError,
    loadPlaces,
    loadPlacesSucceeded,
    loadPlacesFailed,
    loadPlacesAsync,
};
